export const contactData = {
  mobile: "4166884000",
  phone: "9054530000",
  fax: "9059174000",
  email: "info@conceptlegalservices.com",
  address: "Unit 16, 20 Maritime Ontario Blvd, Brampton, ON L6S 0E7",
};
